import { countInvitationHeads, type Guest } from "@amazing-wedding/shared-types";

export function countTotalHeads(guests: Guest[]): number {
  return countInvitationHeads(guests);
}
